import { render, staticRenderFns } from "./MyBidsShortList.vue?vue&type=template&id=477ef382&scoped=true"
import script from "./MyBidsShortList.vue?vue&type=script&lang=js"
export * from "./MyBidsShortList.vue?vue&type=script&lang=js"
import style0 from "./MyBidsShortList.vue?vue&type=style&index=0&id=477ef382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477ef382",
  null
  
)

export default component.exports